import * as React from 'react'
import styled from 'styled-components'

import type { StyleProps } from './ExternalLink'

const ExternalLink = (
  component: React.ComponentType<any>,
  attrs: Function,
): React.ComponentType<any> => {
  const styledComponent = styled(component)
  return styledComponent.attrs(attrs)`
    width: ${({ kind }: StyleProps) => (kind === 'medium' ? '1.5rem' : '.9375rem')};
    height: ${({ kind }: StyleProps) => (kind === 'medium' ? '1.5rem' : '.9375rem')};
  `
}

export default ExternalLink
